export const languageLevelsData = [
  {
    "name": "English",
    "flag": "/images/Languages/united-kingdom.webp",
    "level": "Fluent",
    "cefr": "C2",
    "cefrBg": "#19c37d",
    "icon": "/images/Languages/language-alt-svgrepo-com.svg",
    "details": {
      "speaking": "C2",
      "reading": "C2", 
      "listening": "C2",
      "writing": "C2"
    }
  },
  {
    "name": "Patois",
    "flag": "/images/Languages/jamaica.webp",
    "level": "Fluent",
    "cefr": "C2",
    "cefrBg": "#19c37d",
    "icon": "/images/Languages/language-alt-svgrepo-com.svg",
    "details": {
      "speaking": "C2",
      "reading": "C2",
      "listening": "C2", 
      "writing": "C2"
    }
  },
  {
    "name": "Spanish",
    "flag": "/images/Languages/spain.webp",
    "level": "Intermediate",
    "cefr": "B1",
    "cefrBg": "#FFD600",
    "icon": "/images/Languages/language-alt-svgrepo-com.svg",
    "details": {
      "speaking": "B1",
      "reading": "B2",
      "listening": "A2",
      "writing": "B1"
    }
  },
  {
    "name": "Korean",
    "flag": "/images/Languages/south-korea.webp",
    "level": "Pre-Intermediate",
    "cefr": "A2",
    "cefrBg": "#FF9130",
    "icon": "/images/Languages/language-alt-svgrepo-com.svg",
    "details": {
      "speaking": "A2",
      "reading": "B1",
      "listening": "A2",
      "writing": "A2"
    }
  },
  {
    "name": "German",
    "flag": "/images/Languages/germany.webp",
    "level": "Basic",
    "cefr": "A1",
    "cefrBg": "#FF4A4A",
    "icon": "/images/Languages/language-alt-svgrepo-com.svg",
    "details": {
      "speaking": "A1",
      "reading": "A1",
      "listening": "A2",
      "writing": "A1"
    }
  },
  {
    "name": "French",
    "flag": "/images/Languages/france.webp",
    "level": "Basic",
    "cefr": "A1",
    "cefrBg": "#FF4A4A",
    "icon": "/images/Languages/language-alt-svgrepo-com.svg",
    "details": {
      "speaking": "A1",
      "reading": "A1",
      "listening": "A1",
      "writing": "A1"
    }
  }
];